<template>
  <div class="modal fade" id="ViewSscInfo" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-10 my-auto">
                <h5 class="modal-title" id="ViewSscInfoLabel">Standard Settlement Code (SSC)</h5>
              </div>
              <div class="col-2 my-auto">
                <div>
                  <div>
                    <div>
                      <span>
                        <a class="close">
                          <i class="far fa-times-circle fa-2x" data-dismiss="modal" id="closeViewSscInfo"
                            aria-label="Close"></i>
                        </a>
                      </span>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-lg-12">
                    <div id="SscSearchSection" class="row">
                      <div class="col-6 mb-3 mb-sm-0">
                        <!-- serach box -->
                        <div class="input-group mobile-space-t db_search w-xl-100 mx-auto">
                          <input maxlength="4" v-model="searchId" @keypress.enter="search"
                            class="form-control form-control-lg" type="text" placeholder="Search" aria-label="Search" />
                          <div class="input-group-append pointer" @click="search">
                            <span class="input-group-text amber lighten-3" id="basic-text1">
                              <i class="fa fa-search text-grey" aria-hidden="true"></i>
                            </span>
                          </div>
                        </div>

                        <!-- <div class="col-sm-12 no-pad bg-white db-search-results">
                            <div v-if="(results && (results == 0 || !results)) && searchId.length > 0" class="row">
                              <div class="col-sm">
                                <div class="mx-auto p-3">
                                  <h5>Search Results:</h5>
                                  <p class="d-inline">Sorry, no results found just yet......</p>
                                </div>
                              </div>
                        </div>

                        <div v-else-if="results && results.length >= 1 && searchId.length > 2" class="row">
                              <div class="col-sm">
                                <div class="mx-auto p-3">
                                  <template>
                                    <div class="table-responsive-lg pre-scrollable">
                                      <b-table @row-clicked="setSscResults" responsive hover outlined striped
                                        :items="results" :fields="searchResultFields">
                                        <template slot="Sscref" slot-scope="data">{{data.item.Sscref}}</template>
                                      </b-table>
                                    </div>
                                  </template>
                                </div>
                              </div>
                          </div>
                        </div> -->

                      </div>
                      <!-- <div class="col-sm-6 my-auto">
                        <p class="font-weight-bold mb-0 d-inline">SSC Code:</p>
                        <p class="d-inline mb-0 ml-2">{{sscInfo.Ssc}}</p>
                      </div> -->
                    </div>
                    <hr>
                    <div v-if="sscInfo">
                      <div class="row">
                        <div class="col-sm-6 my-auto">
                          <h5 class="font-weight-bold mb-0 d-inline">{{sscInfo.Ssc}}</h5>
                          <!-- <p class="d-inline mb-0 ml-2"></p> -->
                        </div>
                      </div>
                      <div class="row py-2">
                        <div class="col-sm-6 col-md-3">
                          <div class="row">
                            <div class="col-12">
                              <p class="font-weight-bold d-inline">Effective From:</p>
                              <p class="d-inline ml-2">{{sscInfo.EffectiveFrom | moment('DD.MM.YYYY')}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                          <div class="row">
                            <div class="col-12">
                              <p class="font-weight-bold d-inline">Effective To:</p>
                              <p class="d-inline ml-2" v-if="sscInfo.EffectiveTo">
                                {{sscInfo.EffectiveTo | moment('DD.MM.YYYY')}}</p>
                              <p class="d-inline ml-2" v-else>N/A</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                          <div class="row">
                            <div class="col-12">
                              <p class="font-weight-bold d-inline">Description:</p>
                              <p class="d-inline ml-2">{{sscInfo.Description}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                          <div class="row">
                            <div class="col-12">
                              <p class="font-weight-bold d-inline">Type:</p>
                              <p class="d-inline ml-2">{{sscInfo.Type}}</p>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                    <div class="row" v-if="sscInfo">
                      <div class="col-12 mt-2">

                        <div role="tablist">
                          <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                              <b-button class="bg-transparent border-p text-dark" block href="#"
                                v-b-toggle.SscAccordionResults variant="info">Measurement Requirements</b-button>
                            </b-card-header>
                            <b-collapse id="SscAccordionResults" accordion="ssc-accordion" role="tabpanel">
                              <b-card-body class="pb-3">
                                <div class="row">
                                  <div class="col-sm-6"
                                    v-for="(measurementRequirement) in sscInfo.MeasurementRequirements"
                                    :key="measurementRequirement.Tpr">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <p class="font-weight-bold d-inline">TPR:</p>
                                        <p class="d-inline ml-2">{{measurementRequirement.Tpr}}</p>
                                      </div>
                                      <div class="col-md-6">
                                        <p class="font-weight-bold d-inline">Controlled By:</p>
                                        <p class="d-inline ml-2">{{measurementRequirement.ControlledBy}}</p>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <p class="font-weight-bold d-inline">GMT:</p>
                                        <p class="d-inline ml-2">{{measurementRequirement.Gmt}}</p>
                                      </div>
                                      <div class="col-md-6">
                                        <p class="font-weight-bold d-inline">Common Decode:</p>
                                        <p class="d-inline ml-2">{{measurementRequirement.CommonDecode}}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <span
                                    class="border-right border-secondaryL d-none d-sm-block position-absolute h-100"></span>
                                  <span class="border-bottom border-secondaryL d-block d-sm-none my-3 w-100"></span>
                                </div>
                              </b-card-body>
                            </b-collapse>
                          </b-card>
                          <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                              <b-button class="bg-transparent border-p text-dark" block href="#" v-b-toggle.accordion-2
                                variant="info">Profile Classes</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-2" accordion="ssc-accordion" role="tabpanel">
                              <b-card-body>
                                <div class="row" v-for="(profileClass, index) in sscInfo.ProfileClasses" :key="index">
                                  <div class="col-lg-6">
                                    <div class="row">
                                      <div class="col-12 col-lg-4 no-pad">
                                        <p class="font-weight-bold d-inline">Profile Class Id:</p>
                                        <p class="d-inline ml-2">{{profileClass.ProfileClassId}}</p>
                                      </div>
                                      <div class="col-sm-6 col-lg-4 no-pad">
                                        <p class="font-weight-bold d-inline">Effective From:</p>
                                        <p class="d-inline ml-2">{{profileClass.EffectiveFrom | moment('DD.MM.YYYY')}}
                                        </p>
                                      </div>
                                      <div class="col-sm-6 col-lg-4 no-pad">
                                        <p class="font-weight-bold d-inline">Effective To:</p>
                                        <p class="d-inline ml-2" v-if="profileClass.EffectiveTo">
                                          {{profileClass.EffectiveTo | moment('DD.MM.YYYY')}}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-lg-6">
                                    <div id="SscAccordionInner" class="mx-auto" role="tablist">
                                      <b-card no-body class="mb-1">
                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                          <b-button block href="#"
                                            v-b-toggle="'SwitchedLoadMeasurementRequirementDetailsSection' + index"
                                            variant="primary">Switched Load Indicators</b-button>
                                        </b-card-header>
                                        <b-collapse :id="'SwitchedLoadMeasurementRequirementDetailsSection' + index"
                                          accordion="my-accordion" role="tabpanel">
                                          <b-card-body class="py-0"
                                            v-for="(switchedLoadMeasurement, index) in profileClass.SwitchedLoadMeasurementRequirementDetails"
                                            :key="index">
                                            <div class="row mt-2">
                                              <div class="col-12">
                                                <p class="font-weight-bold d-inline">TPR:</p>
                                                <p class="d-inline ml-2">{{switchedLoadMeasurement.Tpr}}</p>
                                              </div>
                                              <div class="col-12">
                                                <p class="font-weight-bold d-inline">Switched Load Indicator:</p>
                                                <p class="d-inline ml-2">
                                                  {{switchedLoadMeasurement.SwitchedLoadIndicator}}</p>
                                              </div>
                                            </div>
                                            <hr class="mt-2" />
                                          </b-card-body>
                                        </b-collapse>
                                      </b-card>

                                      <b-card no-body class="py-0">
                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                          <b-button block href="#" v-b-toggle="'GspGroupsSection' + index"
                                            variant="primary">GSP Groups
                                          </b-button>
                                        </b-card-header>
                                        <b-collapse :id="'GspGroupsSection' + index" accordion="my-accordion"
                                          role="tabpanel">
                                          <b-card-body class="py-0" v-for="(gspGroup) in profileClass.GspGroups"
                                            :key="gspGroup.Name">
                                            <div class="row mt-2">
                                              <div class="col-lg-6">
                                                <p class="font-weight-bold d-inline ml-2">GspGroupId:</p>
                                                <p class="d-inline ml-2">{{gspGroup.GspGroupId}}</p>
                                              </div>
                                              <div class="col-lg-6">
                                                <p class="font-weight-bold d-inline ml-2">Name:</p>
                                                <p class="d-inline ml-2">{{gspGroup.Name}}</p>
                                              </div>
                                            </div>
                                            <div>
                                              <div class="row">
                                                <div class="col mt-2 bg-secondaryL">
                                                  <p class="font-weight-bold d-inline ml-2">Gsp Group Profile Class
                                                    Average Eacs:</p>
                                                </div>
                                              </div>
                                              <div class="row mt-2 ml-1"
                                                v-for="(gspGroupProfileClassAverageEac, index) in gspGroup.GspGroupProfileClassAverageEacs"
                                                :key="index">
                                                <div class="col-12">
                                                  <p class="font-weight-bold d-inline ml-2">Effective From:</p>
                                                  <p class="d-inline ml-2">
                                                    {{gspGroupProfileClassAverageEac.EffectiveFrom | moment('DD.MM.YYYY')}}
                                                  </p>
                                                </div>
                                                <div class="col-12">
                                                  <p class="font-weight-bold d-inline ml-2">Researched Average Eac:
                                                  </p>
                                                  <p class="d-inline ml-2">
                                                    {{gspGroupProfileClassAverageEac.ResearchedAverageEac}}</p>
                                                </div>
                                              </div>
                                              <hr class="mt-2" />
                                            </div>
                                            <div>
                                              <div class="row">
                                                <div class="col mt-2 bg-secondaryL">
                                                  <p class="font-weight-bold d-inline ml-2">Average Fractions Of Year:
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="row mt-2 ml-1"
                                                v-for="(averageFractionsOfYear, index) in gspGroup.AverageFractionsOfYear"
                                                :key="index">
                                                <div class="col-12">
                                                  <div>
                                                    <p class="font-weight-bold d-inline ml-2">Effective From:</p>
                                                    <p class="d-inline ml-2">
                                                      {{averageFractionsOfYear.EffectiveFrom | moment('DD.MM.YYYY')}}
                                                    </p>
                                                  </div>
                                                  <div>
                                                    <p class="font-weight-bold d-inline ml-2">Effective To:</p>
                                                    <p class="d-inline ml-2" v-if="averageFractionsOfYear.EffectiveTo">
                                                      {{averageFractionsOfYear.EffectiveTo | moment('DD.MM.YYYY')}}
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-12 ml-2"
                                                  v-for="(detail, index) in averageFractionsOfYear.Detail" :key="index">
                                                  <div>
                                                    <p class="font-weight-bold d-inline ml-2">TPR:</p>
                                                    <p class="d-inline ml-2">{{detail.Tpr}}</p>
                                                  </div>
                                                  <div>
                                                    <p class="font-weight-bold d-inline ml-2">Fraction:</p>
                                                    <p class="d-inline ml-2">{{detail.Fraction}}</p>
                                                  </div>
                                                </div>
                                              </div>
                                              <hr class="mt-2" />
                                            </div>
                                          </b-card-body>
                                        </b-collapse>
                                      </b-card>
                                    </div>
                                  </div>
                                </div>
                              </b-card-body>
                            </b-collapse>
                          </b-card>

                          <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                              <b-button class="bg-transparent border-p text-dark" block href="#" v-b-toggle.accordion-3
                                variant="info">Time Pattern Regimes</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-3" accordion="ssc-accordion" role="tabpanel">
                              <b-card-body class="pb-3">
                                <div class="row">
                                  <div class="col-sm-6"
                                    v-for="(timePatternRegimes, index) in sscInfo.TimePatternRegimes" :key="index">
                                    <div class="row">
                                      <div class="col-lg-6">
                                        <p class="font-weight-bold d-inline">TPR:</p>
                                        <p class="d-inline ml-2">{{timePatternRegimes.Tpr}}</p>
                                      </div>
                                      <div class="col-lg-6">
                                        <p class="font-weight-bold d-inline">Common Decode:</p>
                                        <p class="d-inline ml-2">{{timePatternRegimes.CommonDecode}}</p>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-12">
                                        <p class="font-weight-bold d-inline">Registered Type ID:</p>
                                        <p class="d-inline ml-2">{{timePatternRegimes.RegisterTypeId}}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <span
                                    class="border-right border-secondaryL d-none d-sm-block position-absolute h-100"></span>
                                  <span class="border-bottom border-secondaryL d-block d-sm-none my-3 w-100"></span>
                                </div>
                              </b-card-body>
                            </b-collapse>
                          </b-card>
                          <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                              <b-button class="bg-transparent border-p text-dark" block href="#"
                                v-b-toggle.CalendarSection variant="info">Calendar</b-button>
                            </b-card-header>
                            <b-collapse id="CalendarSection" accordion="ssc-accordion" role="tabpanel">
                              <b-card-body>
                                <!-- <div class="row">
                                  <div class="col-sm-6 col-lg-4">
                                    <div class="row">
                                      <div class="col-12">
                                        <p class="font-weight-bold d-inline">Effective From:</p>
                                        <p class="d-inline ml-2">{{sscInfo.EffectiveFrom | moment('DD.MM.YYYY')}}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-6 col-lg-4">
                                    <div class="row">
                                      <div class="col-12">
                                        <p class="font-weight-bold d-inline">Effective To:</p>
                                        <p class="d-inline ml-2">{{sscInfo.EffectiveTo | moment('DD.MM.YYYY')}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div> -->
                                <div class="row">
                                  <div class="col-12 mt-2">
                                    <div>
                                      <apexchart type="heatmap" height="350" :options='calendarOptions'
                                        :series='calendarSeries'></apexchart>
                                      <!-- <b-table class="SscCalendar" responsive :items="itemsComputed"
                                          :fields="fieldsComputed">
                                          <template v-slot:head(id)="scope">
                                          </template>
                                          <template v-slot:head()="scope">
                                            <div class="text-nowrap">{{ scope.label }}</div>
                                          </template>
                                        </b-table> -->
                                    </div>
                                  </div>
                                </div>
                              </b-card-body>
                            </b-collapse>
                          </b-card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Results section end -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment"
  import sscResult from "../../json/SSC_0121.json"
  import tprReference from "../../json/TprReference.json"

  export default {
    data() {
      return {
        searchId: '',
        sscResult: sscResult,
        tprReference: tprReference,
        daysOfWeek: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ]
      };
    },
    computed: {
      sscInfo: {
        get() {
          return this.$store.state.meters.sscInfo
        },
        set(sscInfo) {
          this.$store.commit('updateSscInfo', sscInfo)
        }
      },
      calendarSeries() {
        var series = []
        if (this.sscInfo) {
          this.sscInfo.Calendar[0].Days.forEach(day => {
            series.push({
              name: this.daysOfWeek[day.DayOfWeekId - 1],
              data: this.generateSeriesData(day.Periods)
            })
          });
        }
        series.reverse()
        return series
      },
      calendarOptions() {
        var colours = this.$config.honeycomb.heatmap
        var colourRanges = []
        this.sscInfo.TimePatternRegimes.forEach((tpr, index) => {
          colourRanges.push({
            from: +tpr.Tpr,
            to: +tpr.Tpr,
            color: colours[index],
            name: tpr.Tpr + ' (' + tpr.RegisterTypeId + ')'
          })
        });
        return {
          plotOptions: {
            heatmap: {
              colorScale: {
                ranges: colourRanges
              },
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: 1
          },
          chart: {
            zoom: {
              enabled: false
            },
            toolbar: {
              tools: {
                download: false
              }
            }
          },
          tooltip: {
            x: {
              show: true,
              formatter: function (x, {
                seriesIndex
              }) {
                let daysOfWeek = [
                  'Sunday',
                  'Saturday',
                  'Friday',
                  'Thursday',
                  'Wednesday',
                  'Tuesday',
                  'Monday'
                ]
                return daysOfWeek[seriesIndex] + ' ' + moment().startOf('day').add((x - 1) * 30 * 60, 's').format(
                  'HH:mm')
              }
            },
            y: {
              formatter: (value) => value.toString().padStart(5, '0') + ' (' + this.$_.findWhere(this.sscInfo
                .TimePatternRegimes, {
                  Tpr: value.toString().padStart(5, '0')
                }).RegisterTypeId + ')',

              title: {
                formatter: function () {
                  return 'TPR';
                }
              }
            }
          }
        }
      },
      fieldsComputed() {
        let fields = [{
          key: "Day",
          stickyColumn: true,
          isRowHeader: true,
          variant: "success"
        }];
        for (let i = 1; i <= 48; i++) {
          fields.push(i.toString());
        }
        return fields;
      },
      itemsComputed() {
        let items = [];
        const daysOfWeek = {
          1: "Monday",
          2: "Tuesday",
          3: "Wednesday",
          4: "Thursday",
          5: "Friday",
          6: "Saturday",
          7: "Sunday"
        };
        this.sscResult.Calendar[0].Days.forEach(periodValuesForDay => {
          let dataForDay = {
            _cellVariants: {}
          };
          dataForDay.Day = daysOfWeek[periodValuesForDay.DayOfWeekId];
          periodValuesForDay.Periods.forEach(periodValues => {
            dataForDay[periodValues.PeriodId] = "";
            let rateName = this.GetRateName(periodValues.Tpr);
            dataForDay._cellVariants[periodValues.PeriodId] = rateName;
          });
          items.push($.extend(true, {}, dataForDay));
        });
        return items;
      }
    },
    methods: {
      search: function () {
        this.$store.dispatch('getSscInfo', this.searchId);
        this.searchId = ''
      },
      generateSeriesData(periods) {
        var data = []
        if (periods && periods.length > 0) {
          periods.forEach(period => {
            data.push({
              x: period.PeriodId,
              y: +period.Tpr
            })
          });
        }
        return data
      },
      GetRateName(tpr) {
        let tprRateName = "na";
        let tprReference = Object.keys(this.tprReference);
        tprReference.forEach(rateName => {
          if (this.tprReference[rateName].includes(tpr)) {
            tprRateName = rateName;
          }
        });
        return tprRateName;
      }
    }
  };
</script>